export const scaleNumbers = (inMax, inMin, outMax, outMin, number) => {
	var percent = (number - inMin) / (inMax - inMin);
	return percent * (outMax - outMin) + outMin;
}

// TODO: block tools for mobile as they don't work
export const isMobile = { 
	Android: function() { return navigator.userAgent.match(/Android/i); }, 
	BlackBerry: function() { return navigator.userAgent.match(/BlackBerry/i); }, 
	iOS: function() { return navigator.userAgent.match(/iPhone|iPad|iPod/i); }, 
	Opera: function() { return navigator.userAgent.match(/Opera Mini/i); }, 
	Windows: function() { return navigator.userAgent.match(/IEMobile/i); },
	any: function() { return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows()); } 
};


// WEBPACK FOOTER //
// ./src/utilities.js